// extracted by mini-css-extract-plugin
export default {"root":"role_profile_action_buttons-module___root___d4f5aec5","labelAndIcons":"role_profile_action_buttons-module___labelAndIcons___f7234c17"};